export default __webpack_public_path__ + "static/media/edit_black.7ba36d4c.svg";